import { CardContent, Paper, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const StyledCardHeaderContainer = styled('div')(({ theme }) => ({
  zIndex: 5,
  backgroundColor: theme.palette.background.default,
  marginLeft: theme.spacing(-2),
  marginRight: theme.spacing(-2),
  marginTop: theme.spacing(-2),
}));

export const StyledCardHeader = styled(Paper)<{ sx?: SxProps<Theme> }>(({ theme, sx }) => ({
  ['&']: {
    display: 'flex',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    ...sx,
  },
}));

export const StyledCardContent = styled(CardContent)(({}) => ({
  // ':last-child': {
  //   paddingBottom: theme.spacing(1),
  // },
}));

export const StyledControlsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: 'auto',
  alignItems: 'start',
  '& > :not(:first-of-type):not(:empty)': {
    marginLeft: theme.spacing(2),
  },
}));
